import { useSelector } from 'react-redux';
import { ShipmentConfigurationService } from '../../../services/shipping-configuration-service';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fedexHalDisabledReason: {
    description: 'otherActionsMenu.halDisabledStateButtonTitle',
    defaultMessage: 'One of the selected orders is a HAL order. Combining/splitting HAL orders is not currently supported.',
    id: 'ENcYXu',
  },
});

export const useFedexHalOrderSelectedDisabled = () => {
  const disabled = useSelector((state) => ShipmentConfigurationService.orderSelectionContainsHalService(state) || false);
  return {
    disabled,
    message: messages.messages,
  };
};
